import {
  createContext,
  PropsWithChildren,
  useContext,
  useLayoutEffect,
  useState,
} from "react";
import { useWindowSize } from "../../../helpers/window-size/windowsize";
import { BREAKPOINT_MEDIUM_PIXELS } from "../../../data/constants";

interface SideNavigationCollapseContext {
  isCollapsed: boolean;
  handleCollapse: () => void;
}

const SideNavigationCollapseContext = createContext<
  SideNavigationCollapseContext | undefined
>(undefined);

export const useSideNavigationCollapseContext = () => {
  const context = useContext(SideNavigationCollapseContext);
  if (!context) {
    throw new Error(
      "useSideNavigationCollapseContext must be used within a SideNavigationCollapseProvider",
    );
  }
  return context;
};

export const SideNavigationCollapseProvider = ({
  children,
}: PropsWithChildren) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  // check the media screen size and start collapsed if it's small
  const windowSize = useWindowSize();
  useLayoutEffect(() => {
    if (windowSize.width <= BREAKPOINT_MEDIUM_PIXELS) {
      setIsCollapsed(true);
    }
  }, [windowSize]);

  const handleCollapse = () => {
    setIsCollapsed((prev) => !prev);
  };

  return (
    <SideNavigationCollapseContext.Provider
      value={{ isCollapsed, handleCollapse }}
    >
      {children}
    </SideNavigationCollapseContext.Provider>
  );
};
